module.exports = __webpack_public_path__ + "static/assets/ff91c1b5459576978a684cead1eaf293.png";